import adminTable from '@store/adminTable/reducers';

import { setting } from '@Modules/Setting/configs/constants';

export default adminTable(setting);
